import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const SampleInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Sample"
    sectionDisplayName="Sample Section"
    backRoute="/sections/sample"
  />
);

export default SampleInwardConsignment;
